import { AbstractControl, ValidationErrors } from '@angular/forms';

export function alphanumericValidator(control: AbstractControl): ValidationErrors | null {
  const valid = /^[a-zA-Z0-9]*$/.test(control.value);
  return valid ? null : { alphanumeric: true };
}
